import React from "react";
function Flex_Container(props){
    return(
        <div className="my_container" >{props.children}</div>
    );
}
export default Flex_Container;